//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getSubPage from '../mixins/getSubPage'
export default {
    mixins: [
        getSubPage
    ],
    props: {
        building_id: {
            type: [String, Number]
        },
        show_surplus_houses: {
            type: Boolean,
        },
        surplus_apartment_count: {
            type: Number,
        },
        surplus_houses: {
            type: Array
        }
    },
    methods: {
        goSurplusApartments (e) {
            const { building_id } = this.$route.query
            const { name, id: house_id } = e.currentTarget.dataset
            this.goSubPagePath(`/building/price?building_id=${building_id}&title=${name}&house_id=${house_id}&type=surplus_apartments`)
        }
    }
}
